import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import { Dropdown, type MenuProps } from 'antd';
import { DownOutlined } from '@ant-design/icons';
import {
  useAggregationConfig,
  type AggregationType,
} from '../../../../hooks/SimViewer/useAggregationConfig';
import { toCamel } from '../../../../utils/case';

type MenuItem = NonNullable<MenuProps['items']>[number];

const AggregationTypeSwitcher = (): ReactNode => {
  const { t } = useTranslation();
  const {
    aggregationConfig,
    availableAggregationTypes,
    changeAggregationType,
  } = useAggregationConfig();

  if (!aggregationConfig?.type) {
    return null;
  }
  return (
    <Dropdown
      trigger={['click']}
      disabled={availableAggregationTypes.length <= 1}
      menu={{
        items: availableAggregationTypes.map(
          (type: AggregationType): MenuItem => {
            return {
              key: type,
              label: t(`aggregationTypes.${toCamel(type)}`, {
                defaultValue: type,
              }),
              onClick: (): void => {
                changeAggregationType(type);
              },
            };
          }
        ),
      }}
    >
      <DropdownButton
        type="button"
        disabled={availableAggregationTypes.length <= 1}
      >
        <ButtonLabel>
          {t(`aggregationTypes.${toCamel(aggregationConfig.type)}`, {
            defaultValue: aggregationConfig.type,
          })}
        </ButtonLabel>
        <DownOutlined style={{ fontSize: 12, paddingInline: 4 }} />
      </DropdownButton>
    </Dropdown>
  );
};

const DropdownButton = styled.button`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 32px;
  font-size: 14px;
  padding: 0 4px;
  background-color: #d9d9d9a6;
  border: none;
  border-radius: 2px;
  cursor: pointer;
  :hover:not([disabled]) {
    background-color: #d9d9d9;
  }
  &[disabled],
  &:disabled {
    cursor: not-allowed;
  }
`;

const ButtonLabel = styled.span`
  display: inline-flex;
  flex: 1;
  justify-content: center;
  align-items: center;
`;

export { AggregationTypeSwitcher };
